import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
export default class ListaCertificados {
    constructor() {
        this.sections = document.querySelectorAll('.component-lista_certificados');

        this.ready();

    }

    ready() {

        this.sections.forEach(section => {
            const slider = section.querySelector('.swiper')
            const swiper = new Swiper(slider, {
                modules: [Navigation, Pagination],
                grabCursor: true,
                allowTouchMove: true,
                loop: false,
                navigation: {
                    nextEl: section.querySelector('.slider-button-next'),
                    prevEl: section.querySelector('.slider-button-prev'),
                },
                pagination: {
                    el: section.querySelector('.swiper-pagination-nav'),
                    type: 'fraction',
                    renderFraction: (currentClass, totalClass) => {
                        return `
                            <span class="${currentClass}"></span> /
                            <span class="${totalClass}"></span>
                        `;
                    },
                },
                breakpoints: {
                    0: {
                        slidesPerView: "auto",
                        spaceBetween: 24,
                    },
                    1270: {
                        slidesPerView: 5,
                        spaceBetween: 52,
                    }
                },
                on: {
                    init: function () {
                        ListaCertificados.formatPagination(section);
                    },
                    slideChange: function () {
                        ListaCertificados.formatPagination(section);
                    },
                }
            });
        })

    }

    static formatPagination(section) {
        const currentElement = section.querySelector('.swiper-pagination-nav .swiper-pagination-current');
        const totalElement = section.querySelector('.swiper-pagination-nav .swiper-pagination-total');

        if (currentElement) {
            currentElement.textContent = currentElement.textContent.padStart(2, '0');
        }
        if (totalElement) {
            totalElement.textContent = totalElement.textContent.padStart(2, '0');
        }
    }

}

if (document.querySelector('.component-lista_certificados')) {
    new ListaCertificados();
}